import React from 'react';
import PropTypes from 'prop-types';
import { ValidatingSelect, ValidatingInput, ValidatingTextArea, Message } from '../../';

export default class PaypalAccount extends React.Component {
    static propTypes = {
        schema: PropTypes.object,
        onChange: PropTypes.func,
        getValue: PropTypes.func,
        disabled: PropTypes.bool,
        foreignBankValue: PropTypes.bool
    };

    render() {
        const { schema, onChange, getValue, foreignBankValue, disabled } = this.props;
        const { foreignBank, checkName, bankName, routingNo, bankAccountNo, swiftCode, accountDetails } = schema;
        const foreignBankOptions = [{ value: true, label: foreignBank.optionLabel.yes }, { value: false, label: foreignBank.optionLabel.no }];
        const bankInformation = `
            <div>
                <p>${routingNo.display.toolTip}</p>
                <div class='bank-img'></div>
            </div>
        `;

        return (
            <div>
                <h2 className="payout-title">
                    <Message code="epic.esport.label.bank_account" />
                </h2>
                <div className="row">
                    <ValidatingSelect
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        name={foreignBank.identifier}
                        options={foreignBankOptions}
                        value={getValue(foreignBank.identifier)}
                        onChange={onChange(foreignBank.identifier)}
                        disabled={disabled}
                    />
                    <ValidatingInput
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        name={checkName.identifier}
                        value={getValue(checkName.identifier)}
                        onChange={onChange(checkName.identifier)}
                        placeholder={checkName.display.text}
                        validations={disabled ? {} : checkName.validations}
                        validationErrors={checkName.validationMessages}
                        required={checkName.required}
                        disabled={disabled}
                    />
                    <ValidatingInput
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        name={bankName.identifier}
                        value={getValue(bankName.identifier)}
                        onChange={onChange(bankName.identifier)}
                        placeholder={bankName.display.text}
                        validations={disabled ? {} : bankName.validations}
                        validationErrors={bankName.validationMessages}
                        required={bankName.required}
                        disabled={disabled}
                    />

                    <ValidatingInput
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input routingNo"
                        name={routingNo.identifier}
                        value={getValue(routingNo.identifier)}
                        onChange={onChange(routingNo.identifier)}
                        placeholder={routingNo.display.text}
                        validations={disabled ? {} : routingNo.validations}
                        validationErrors={routingNo.validationMessages}
                        toolTipMessage={bankInformation}
                        required={foreignBankValue ? false : routingNo.required}
                        showTooltip={true}
                        disabled={disabled}
                        maxLength={9}
                    />

                    <ValidatingInput
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input bankAccountNo"
                        name={bankAccountNo.identifier}
                        value={getValue(bankAccountNo.identifier)}
                        onChange={onChange(bankAccountNo.identifier)}
                        placeholder={foreignBankValue ? bankAccountNo.display.text_IBAN : bankAccountNo.display.text_bankAccountNo}
                        validations={disabled ? {} : bankAccountNo.validations}
                        validationErrors={bankAccountNo.validationMessages}
                        toolTipMessage={bankInformation}
                        required={disabled ? false : bankAccountNo.required}
                        showTooltip={true}
                        disabled={disabled}
                    />

                    {foreignBankValue && (
                        <ValidatingInput
                            customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                            name={swiftCode.identifier}
                            value={getValue(swiftCode.identifier)}
                            onChange={onChange(swiftCode.identifier)}
                            placeholder={swiftCode.display.text}
                            validations={disabled ? {} : swiftCode.validations}
                            validationErrors={swiftCode.validationMessages}
                            required={disabled ? false : swiftCode.required}
                            disabled={disabled}
                        />
                    )}

                    <ValidatingTextArea
                        customClassNames="col-xs-12 col-md-12 col-lg-12 code-input textarea-input"
                        name={accountDetails.identifier}
                        value={getValue(accountDetails.identifier)}
                        onChange={onChange(accountDetails.identifier)}
                        placeholder={accountDetails.display.text}
                        validations={disabled ? {} : accountDetails.validations}
                        validationErrors={accountDetails.validationMessages}
                        required={accountDetails.required}
                        disabled={disabled}
                    />
                </div>
            </div>
        );
    }
}
